import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "p-component" }
const _hoisted_2 = { class: "p-component p-fluid p-grid" }
const _hoisted_3 = {
  key: 0,
  class: "p-field p-col-12"
}
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = { for: "description" }
const _hoisted_6 = { class: "p-field p-col-12" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { for: "to" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "p-field p-col-12" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { for: "subject" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-fluid p-formgrid p-input-filled" }
const _hoisted_15 = { class: "p-field-checkbox p-m-4" }
const _hoisted_16 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_EmailForm = _resolveComponent("EmailForm")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      loading: _ctx.loading,
      label: _ctx.$t('Squeeze.Validation.Email.SendMail'),
      type: "button",
      icon: "mdi mdi-email-send-outline",
      class: "p-button",
      onClick: _ctx.sendMail
    }, null, 8, ["loading", "label", "onClick"]),
    _createVNode(_component_SplitButton, {
      class: "p-button-md p-ml-2",
      label: _ctx.labelSplitButton,
      model: _ctx.toolbarOptions
    }, null, 8, ["label", "model"]),
    (_ctx.showSaveTemplate)
      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
          key: 0,
          loading: _ctx.loadingSaveTemplate,
          type: "button",
          icon: "mdi mdi-content-save-outline",
          class: "p-button p-ml-2",
          onClick: _ctx.saveTemplate
        }, null, 8, ["loading", "onClick"])), [
          [_directive_tooltip, _ctx.$t('Squeeze.Validation.Email.SaveTemplate')]
        ])
      : _createCommentVNode("", true),
    (_ctx.showEditTemplate)
      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
          key: 1,
          loading: _ctx.loadingSaveTemplate,
          type: "button",
          icon: "mdi mdi-pencil-outline",
          class: "p-button p-ml-2",
          onClick: _ctx.editTemplate
        }, null, 8, ["loading", "onClick"])), [
          [_directive_tooltip, _ctx.$t('Squeeze.Validation.Email.EditTemplate')]
        ])
      : _createCommentVNode("", true),
    (_ctx.showDeleteTemplate)
      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
          key: 2,
          loading: _ctx.loadingSaveTemplate,
          type: "button",
          icon: "mdi mdi-close",
          class: "p-button p-button-danger p-ml-2",
          onClick: _ctx.openDeleteTemplateDialog
        }, null, 8, ["loading", "onClick"])), [
          [_directive_tooltip, _ctx.$t('Squeeze.Validation.Email.DeleteTemplate')]
        ])
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                id: "description",
                modelValue: _ctx.activeMailTemplate.description,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeMailTemplate.description) = $event)),
                modelModifiers: { trim: true },
                required: "true",
                autofocus: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.Validation.Email.TemplateDescription')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_InputText, {
            id: "to",
            modelValue: _ctx.mailBody.to,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mailBody.to) = $event)),
            class: _normalizeClass({'p-invalid': _ctx.v$.to.$invalid && _ctx.showErrorMessage}),
            required: "true",
            autofocus: ""
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.Validation.Email.To')), 1)
        ]),
        (_ctx.showErrorMessage)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, [
              (_ctx.v$.to.checkEmail.$invalid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.Email')), 1)
                  ], 64))
                : (_ctx.v$.to.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Validation.Email.To')})), 1)
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_InputText, {
            id: "subject",
            modelValue: _ctx.mailBody.subject,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mailBody.subject) = $event)),
            modelModifiers: { trim: true },
            class: _normalizeClass({'p-invalid': _ctx.v$.subject.$invalid && _ctx.showErrorMessage}),
            required: "true",
            autofocus: ""
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.Validation.Email.Subject')), 1)
        ]),
        (_ctx.v$.subject.$invalid && _ctx.showErrorMessage)
          ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Validation.Email.Subject')})), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_EmailForm, {
      onChange: _ctx.onChangeForm,
      value: _ctx.mailBody.body
    }, null, 8, ["onChange", "value"]),
    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.Validation.Email.Attachments')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
        return (_openBlock(), _createElementBlock("div", {
          key: file.id,
          class: "p-field-checkbox p-m-4"
        }, [
          _createVNode(_component_Checkbox, {
            name: file.id,
            value: file,
            modelValue: _ctx.activatedFiles,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activatedFiles) = $event))
          }, null, 8, ["name", "value", "modelValue"]),
          _createElementVNode("label", {
            for: file.id
          }, _toDisplayString(file.fileName), 9, _hoisted_16)
        ]))
      }), 128))
    ]),
    _createVNode(_component_DialogDelete, {
      headerLabel: _ctx.$t('Squeeze.Validation.Email.DeleteTemplate'),
      messageLabel: _ctx.$t('Squeeze.Validation.Email.DeleteMassageConfirm'),
      showDialog: _ctx.showDeleteTemplateDialog,
      onOnClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteTemplateDialog = false)),
      onOnConfirm: _ctx.deleteTemplate
    }, null, 8, ["headerLabel", "messageLabel", "showDialog", "onOnConfirm"])
  ]))
}